import React from 'react'
import T from 'prop-types'
import { Stack, Typography } from '@mui/material'

export default function CarCardAdditionalDetailsItem({
  vertical,
  title,
  titleProps,
  value,
  valueProps,
  valueNode,
  id,
  stackProps,
}) {
  return (
    <Stack
      direction={vertical ? 'row' : undefined}
      sx={{
        ...stackProps,
        px: vertical ? undefined : 1,
        justifyContent: vertical ? 'space-between' : undefined,
        mb: vertical ? 1.5 : undefined,
      }}
    >
      <Typography
        variant={'caption'}
        component="p"
        color={'textSecondary'}
        {...titleProps}
        sx={{ pb: vertical ? undefined : 0.25, ...titleProps?.sx }}
      >
        {title}
      </Typography>
      {valueNode ? (
        valueNode
      ) : (
        <Typography
          variant={'body2'}
          component="p"
          color="textPrimary"
          {...valueProps}
          data-testid={`car-price-view-${id}`}
        >
          {value}
        </Typography>
      )}
    </Stack>
  )
}

CarCardAdditionalDetailsItem.propTypes = {
  vertical: T.bool,
  title: T.string,
  value: T.oneOfType([T.string, T.number]),
  titleProps: T.object,
  valueProps: T.object,
  valueNode: T.node,
  stackProps: T.object,
}
